// Inline React version of src/assets/logo-mark.svg — kept as a component
// so it scales crisply at any size without an extra image request.
function LogoMark(props) {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <clipPath id="logoMarkClip">
          <circle cx="100" cy="100" r="90" />
        </clipPath>
      </defs>

      <g clipPath="url(#logoMarkClip)">
        <rect x="0" y="0" width="200" height="200" fill="#1f4a39" />
        <polygon points="200,0 200,200 0,200" fill="#1c2942" />
      </g>

      <line x1="8" y1="192" x2="192" y2="8" stroke="#c9a769" strokeWidth="3" />
      <circle cx="100" cy="100" r="90" fill="none" stroke="#c9a769" strokeWidth="5" />

      <g transform="translate(48,46) rotate(-38)">
        <path d="M0,0 C24,-4 42,14 42,36 C18,36 0,22 0,0 Z" fill="#ddc48f" />
        <path
          d="M3,3 L36,30"
          stroke="#123526"
          strokeWidth="2.4"
          strokeLinecap="round"
          fill="none"
        />
      </g>

      <g transform="translate(112,112)">
        <path
          d="M18,0 C28,13 36,23 36,33 A18,18 0 1 1 0,33 C0,23 8,13 18,0 Z"
          fill="#ddc48f"
        />
        <path
          d="M9,26 C9,20 12,15 16,11"
          stroke="#fffcf7"
          strokeWidth="2.2"
          strokeLinecap="round"
          fill="none"
          opacity="0.65"
        />
      </g>
    </svg>
  );
}

export default LogoMark;
